import axios from "axios";
import {config} from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
import genericStore from "../generic_store";

export default {
    namespaced: true,
    state: {
        endpoint: "settings",
        object: "setting",
        status: "",
        selected_rows: [],
        header: [
            { text: "ID", value: "id" },
            // { text: "Description", value: "description" },
            { text: "Actions", value: "actions", sortable: false }
        ],
        list: [],
        page: 1,
        total: 0,
        options: {
            itemsPerPage: 10,
            search: ""
        }
    },
    mutations: {
        ...genericStore.mutations,
        
        request(state) {
            state.status = "loading";
        },
        success(state, data) {
            state.status = "success";

            if (data && data["list"]) {
                state.list = data["list"];
            }

            if (data && data["total"]) {
                state.total = data["total"];
            }
        },
        error(state) {
            state.status = "error";
        },
        options(state, data) {
            state.options = data;
        }
    },
    actions: {
        ...genericStore.actions,
    },
    getters: {

        ...genericStore.getters,

        status(state) {
            return state.status;
        }
    },
    modules: {}
};
